import React from "react";
import * as styles from "../newStyles.styles";

function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "white",
        width: "100%",
        position: "relative",
        zIndex: 2,
        clear: "both",
        flex: 1,
      }}
    >
      <div
        className={styles.row + " " + styles.offwhite + " " + styles.footer}
        style={{ paddingTop: "15px" }}
      >
        <div className={styles.col + " " + styles.col1}>
          <img
            className={styles.footerLogo}
            src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Logo_footer.png"
            alt="footer-img"
          ></img>
          <nav className={styles.footerNav}>
            <ul className={styles.footerList}>
              <li className={styles.footerListItem + " " + styles.footerOrder1}>
                <div className={styles.footerRowContainer}>
                  <span style={{ padding: "0px 8px" }}>Download the App</span>
                  <span className={styles.footerIcon}>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.mobile360.android"
                      target="_blank"
                    >
                      <svg viewBox="147 0 25 29" width="24" height="28">
                        <g fill="none">
                          <path
                            d="M148.77 9.06c-.98 0-1.77.77-1.77 1.72v7.24c0 .95.8 1.72 1.77 1.72.98 0 1.76-.78 1.76-1.72v-7.24c0-.95-.8-1.72-1.76-1.72zm14.27-6.5l1.24-2.2c.06-.12.02-.26-.1-.33-.1-.06-.27-.02-.33.1l-1.25 2.22c-1.05-.45-2.22-.7-3.47-.7-1.24 0-2.4.24-3.46.7L154.43.13a.26.26 0 0 0-.34-.1c-.12.06-.17.2-.1.33l1.23 2.2c-2.43 1.22-4.07 3.55-4.07 6.22h15.94c0-2.67-1.63-5-4.06-6.22zm-7.54 3.4c-.36 0-.67-.3-.67-.65 0-.35.3-.64.67-.64.37 0 .67.3.67.65 0 .37-.3.66-.67.66zm7.27 0c-.37 0-.67-.3-.67-.65 0-.35.3-.64.67-.64.36 0 .66.3.66.65 0 .37-.3.66-.66.66zm-11.55 3.42V20.6c0 1.02.84 1.85 1.9 1.85h1.28v3.83c0 .94.8 1.72 1.76 1.72.98 0 1.77-.78 1.77-1.73v-3.83h2.4v3.83c0 .95.78 1.72 1.76 1.72.97 0 1.76-.78 1.76-1.73v-3.83h1.3c1.03 0 1.88-.82 1.88-1.85V9.37h-15.82zm20.05 1.4c0-.96-.8-1.72-1.77-1.72-.98 0-1.77.77-1.77 1.72v7.24c0 .95.8 1.72 1.77 1.72.98 0 1.77-.78 1.77-1.72v-7.24z"
                            id="AndroidGroup"
                            fill="#465362"
                          ></path>
                        </g>
                      </svg>
                    </a>
                  </span>
                  <span className={styles.footerIcon}>
                    <a
                      href="https://apps.apple.com/us/app/mobile360/id1466921046"
                      target="_blank"
                    >
                      <svg viewBox="0 0 25 29" width="23" height="28">
                        <g fill="none">
                          <path
                            id="apple-leaf"
                            d="M15.657 4.468c.967-1.191 1.63-2.812 1.445-4.457-1.4.06-3.15.954-4.158 2.119-.892 1.027-1.69 2.71-1.483 4.293 1.572.115 3.187-.782 4.196-1.955z"
                            fill="#465362"
                          ></path>
                          <g transform="translate(0 6.496)">
                            <path
                              id="apple-logo"
                              d="M19.199 8.305c-.033-3.514 2.92-5.223 3.055-5.303C20.582.601 17.99.272 17.08.246 14.902.021 12.791 1.53 11.682 1.53 10.55 1.53 8.843.27 7.002.305 4.635.341 2.42 1.692 1.205 3.79-1.304 8.066.566 14.351 2.969 17.807c1.202 1.693 2.606 3.584 4.444 3.517 1.799-.073 2.47-1.13 4.64-1.13 2.151 0 2.782 1.13 4.657 1.088 1.93-.03 3.145-1.701 4.305-3.41 1.389-1.94 1.946-3.85 1.968-3.949-.045-.015-3.748-1.407-3.784-5.618z"
                              fill="#465362"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </a>
                  </span>
                </div>
              </li>
              <li
                className={
                  styles.footerListItem +
                  " " +
                  styles.footerListItemLinks +
                  " " +
                  styles.footerOrder2
                }
              >
                <ul className={styles.footerListNone}>
                  <li>
                    <div>
                      <strong>Mobile360</strong>
                    </div>
                    <a className={styles.footerATag} href={"/pricing"}>
                      Pricing
                    </a>
                  </li>
                  <li>
                    <a className={styles.footerATag} href={"/contact"}>
                      Contact
                    </a>
                  </li>
                  <li>
                    <a className={styles.footerATag} href={"/partners"}>
                      Partnerships
                    </a>
                  </li>
                  <li>
                    <a className={styles.footerATag} href={"/newsletters"}>
                      Newsletters
                    </a>
                  </li>
                </ul>
              </li>
              <li
                className={
                  styles.footerListItem +
                  " " +
                  styles.footerListItemLinks +
                  " " +
                  styles.footerOrder3
                }
              >
                <ul className={styles.footerListNone}>
                  <strong>Community</strong>
                  <li>
                    <a className={styles.footerATag} href={"/faqs"}>
                      FAQS
                    </a>
                  </li>
                  <li>
                    <a
                      className={styles.footerATag}
                      href={"/terms"}
                      target="_blank"
                    >
                      Terms of Service
                    </a>
                  </li>
                  <li>
                    <a
                      className={styles.footerATag}
                      href={"/privacy_policy"}
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                  </li>
                </ul>
              </li>
              <li
                className={styles.footerListItem + " " + styles.footerOrder4}
                style={{ alignSelf: "center" }}
              >
                <ul className={styles.socialMediaList}>
                  <li className={styles.socialMediaItem}>
                    <a
                      className={styles.footerIcon + " " + styles.footerATag}
                      href={"https://www.facebook.com/mobile360.io"}
                      target="_blank"
                    >
                      <svg width="41" height="40" viewBox="52 0 41 40">
                        <title>Facebook</title>
                        <g fill="none" transform="translate(52)">
                          <ellipse
                            cx="20"
                            cy="20"
                            fill="#465362"
                            rx="20"
                            ry="20"
                          ></ellipse>
                          <path
                            fill="#fff"
                            d="M21.78 30.9v-9.8H25l.44-3.77h-3.77V14.9c0-1.12.33-1.9 1.9-1.9h2V9.56c-.35 0-1.57-.12-2.9-.12-2.9 0-4.9 1.78-4.9 5v2.78h-3.33V21h3.34v9.78h4v.1z"
                          ></path>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li className={styles.socialMediaItem}>
                    <a
                      className={styles.footerIcon + " " + styles.footerATag}
                      href={
                        "https://www.youtube.com/channel/UCiv8K4jkSdMkCKswTbPiAdQ/featured"
                      }
                      target="_blank"
                    >
                      <svg
                        class="youtube-svg"
                        width="41"
                        height="40"
                        viewBox="156 0 41 40"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <title>Youtube</title>
                        <defs>
                          <ellipse
                            id="yt-path"
                            cx="20"
                            cy="20"
                            rx="20"
                            ry="20"
                          ></ellipse>
                        </defs>
                        <g
                          id="social-icon-youtube"
                          fill="none"
                          fillRule="evenodd"
                          transform="translate(156)"
                        >
                          <mask id="yt-mask" fill="#fff">
                            <use xlinkHref="#yt-path"></use>
                          </mask>
                          <use
                            id="Oval"
                            fill="#465362"
                            xlinkHref="#yt-path"
                          ></use>
                          <g id="Group" mask="url(#yt-mask)">
                            <g id="Shape">
                              <path
                                fillOpacity=".25"
                                fill="#465362"
                                d="M8.798 4.645l5.213 3.443.684-.39z"
                                transform="translate(8.889 12.222)"
                              ></path>
                              <path
                                d="M21.968 12.272s-.216 1.534-.88 2.21c-.843.886-1.787.89-2.22.942-3.101.225-7.757.232-7.757.232s-5.76-.052-7.533-.223c-.493-.093-1.6-.065-2.443-.952-.665-.675-.88-2.21-.88-2.21s-.223-1.8-.223-3.602V6.981c0-1.802.222-3.603.222-3.603s.216-1.534.88-2.21c.843-.886 1.788-.89 2.22-.942C6.456 0 11.107 0 11.107 0h.01s4.651 0 7.752.225c.433.052 1.377.056 2.22.943.664.675.88 2.209.88 2.209s.222 1.801.222 3.603v1.688a33.75 33.75 0 0 1-.222 3.603zM8.798 4.645v6.27l5.88-3.201-5.88-3.069z"
                                fill="#fff"
                                transform="translate(8.889 12.222)"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li className={styles.socialMediaItem}>
                    <a
                      className={styles.footerIcon + " " + styles.footerATag}
                      href={"https://www.instagram.com/mobile360.io/"}
                      target="_blank"
                    >
                      <svg
                        class="instagram-svg"
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                      >
                        <title>Instagram</title>
                        <g fill="none">
                          <circle
                            cx="20"
                            cy="20"
                            r="20"
                            fill="#465362"
                          ></circle>
                          <path
                            d="M20 9c-3 0-3.36.02-4.54.07-1.17.06-1.97.24-2.67.5-.73.3-1.34.67-1.95 1.28-.62.6-1 1.23-1.27 1.95-.27.7-.46 1.5-.5 2.67C9 16.64 9 17.02 9 20c0 3 0 3.36.07 4.54.05 1.17.24 1.97.5 2.67.3.73.66 1.34 1.28 1.95.6.62 1.22 1 1.94 1.27.7.27 1.5.46 2.66.5C16.64 31 17 31 20 31c2.98 0 3.36 0 4.53-.07 1.17-.05 1.97-.24 2.67-.5.72-.3 1.34-.66 1.95-1.28.6-.6.98-1.22 1.27-1.94.27-.7.45-1.5.5-2.66C31 23.36 31 23 31 20c0-2.98-.02-3.36-.07-4.53-.06-1.17-.24-1.97-.5-2.67-.3-.72-.67-1.34-1.28-1.95-.6-.6-1.23-.98-1.95-1.27-.7-.27-1.5-.45-2.67-.5C23.36 9 22.98 9 20 9zm0 2c2.93 0 3.28 0 4.44.05 1.07.05 1.65.23 2.04.38.52.2.88.44 1.27.82.38.4.62.75.82 1.27.15.4.33.97.38 2.04.05 1.16.06 1.5.06 4.44 0 2.94 0 3.3-.05 4.45-.05 1.07-.23 1.65-.38 2.04-.2.5-.44.87-.82 1.25-.4.4-.75.63-1.27.83-.4.15-.97.33-2.04.37-1.16.06-1.5.07-4.44.07-2.94 0-3.3 0-4.45-.07-1.07-.04-1.65-.22-2.04-.37-.5-.2-.87-.44-1.25-.83-.4-.38-.63-.75-.83-1.26-.15-.4-.33-.98-.37-2.05-.06-1.16-.07-1.5-.07-4.45 0-2.93 0-3.28.07-4.44.04-1.07.22-1.65.37-2.04.2-.52.44-.88.83-1.27.38-.38.75-.62 1.26-.82.4-.15.98-.33 2.05-.38C16.7 11 17.05 11 20 11zm0 12.67a3.666 3.666 0 1 1-.008-7.332A3.666 3.666 0 0 1 20 23.67zm0-9.3c-3.12 0-5.65 2.5-5.65 5.63A5.65 5.65 0 0 0 20 25.65c3.12 0 5.64-2.53 5.64-5.65 0-3.12-2.52-5.64-5.64-5.64zm7.2-.24a1.325 1.325 0 0 1-2.65 0c0-.73.6-1.32 1.32-1.32.73 0 1.32.6 1.32 1.33"
                            fill="#fff"
                          ></path>
                        </g>
                      </svg>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>

          <styles.P className={styles.footerText}>
            Contact Us: (510) 456-0601 | team@mobile360.io | © 2021 Mobile360
            Inc.
          </styles.P>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
